// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1xAGy","question":"Question_question__15HiS","description":"Question_description__3adKQ"};